module.exports = __webpack_public_path__ + "site/img/28.15881275.jpg";